class CardHover {
  constructor() {
    CardHover.handleHover();
  }

  static handleHover() {
    window.cardBgReveal = (e) => {
      const offset = 100; // offset around element
      const rect = e.target.getBoundingClientRect();
      const newX = e.offsetX;
      const newY = e.offsetY;

      if(newX < -offset || newX > (rect.width + offset)){
        e.target.style.setProperty('--bgOpacity', 0);
        return;
      }

      const x = e.offsetX;

      if(newY < -offset || newY > (rect.height + offset)){
        e.target.style.setProperty('--bgOpacity', 0);
        return;
      }

      const y = e.offsetY;

      e.target.style.setProperty('--bgX', `${x}px`);
      e.target.style.setProperty('--bgY', `${y}px`);
    };

    [].forEach.call(window.wrapper.querySelectorAll('a.card--push'), (link) => {
      link.addEventListener('mousemove', window.cardBgReveal);
    });
  }
}

export default CardHover;
